import { ls } from "../LocalStorage";
import CryptoES from 'crypto-es';
import { ENCRYPT_KEY } from "../../processENV";

export function encryptAndStoreInLocalStorage(key, data) {
    let ecytData = encrypt(JSON.stringify(data), key);
    let encryptedKey = encrypt(key, ENCRYPT_KEY);
    ls.setItem(encryptedKey, ecytData);
    return true;
}

/**
 * Decrypt the json object and retive data from localstorage
 * @param {string} key Localstorage Key
 */
export function getFromLocalStorageAndDecrypt(key) {
    let encryptedKey = encrypt(key, ENCRYPT_KEY);
    let lsData = ls.getItem(encryptedKey);
    try {
        let dcypData = decrypt(lsData, key);
        return JSON.parse(dcypData);
    } catch (error){
        return lsData;
    }    
}

export function deleteItemFromLocalStorage(key) {
    let encryptedKey = encrypt(key, ENCRYPT_KEY);
    localStorage.removeItem(encryptedKey);
}


const encrypt = (data, key) => {
    const encryptKey = CryptoES.enc.Hex.parse(CryptoES.SHA256(key, 64));
    return CryptoES.AES.encrypt(encodeURIComponent(data), encryptKey, { mode: CryptoES.mode.ECB }).toString();
};
  
const decrypt = (data, key) => {
    const decryptKey = CryptoES.enc.Hex.parse(CryptoES.SHA256(key, 64));
    return decodeURIComponent(CryptoES.AES.decrypt(data, decryptKey, { mode: CryptoES.mode.ECB }).toString(CryptoES.enc.Utf8));
};




